import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';

import Header from './header';
import Footer from './footer';
import '../styles/app.scss';

const Layout = ( props ) => {
    console.log(props);
    const children = props.children;
    return (
        <StaticQuery
            query={graphql`
                query SiteTitleQuery {
                    site {
                        siteMetadata {
                            title
                        }
                    }
                }
            `}

            render={data => (
                <React.Fragment>
                    {/* Document Info */}
                    <Helmet
                        title={data.site.siteMetadata.title}
                        meta={[
                            { name: 'description', content: 'Sample' },
                            { name: 'keywords', content: 'sample, something' },
                        ]}
                    >
                        <html lang="en" />
                    </Helmet>

                    {/* Header */}
                    <Header />

                    {/* Page Content Render */}
                    {children}

                    {/* Footer */}
                    <Footer />
                </React.Fragment>
            )}
        />
    )

}

Layout.propTypes = {
    children: PropTypes.node.isRequired,
}

export default Layout
